























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import numeral from 'numeral';
import quotationServices from '@/services/quotation-services';

@Component({
    name: 'LinkedTTH'
})
export default class LinkedTTH extends Vue {
    @Prop({ required: true })
    private quotationId!: number | string;

    @Prop({ default: () => [] })
    private initialTth!: any[];

    private items: any[] = [];
    private isLoading: boolean = false;

    private created() {
        if (Array.isArray(this.initialTth) && this.initialTth.length > 0) {
            this.items = this.initialTth;
        }
    }

    @Watch('initialTth', { immediate: true })
    private onInitialTthChange(val: any[]) {
        if (Array.isArray(val) && val.length > 0) {
            this.items = val;
        } else if (!this.items || this.items.length === 0) {
            this.fetchData();
        }
    }

    private async fetchData() {
        if (!this.quotationId) return;
        this.isLoading = true;
        try {
            const res: any = await quotationServices.getLinkedTth(this.quotationId);
            if (res && res.data) {
                if (Array.isArray(res.data.data)) {
                    this.items = res.data.data;
                } else if (Array.isArray(res.data)) {
                    this.items = res.data;
                } else if (res.data.status === 200 && Array.isArray(res.data.data)) {
                    this.items = res.data.data;
                }
            }
        } catch (e) {
            console.error('Không thể tải đơn TTH liên kết:', e);
        } finally {
            this.isLoading = false;
        }
    }

    private openTthDetail(item: any) {
        if (!item || !item.id) return;
        const routeName = item.type === 'uy_quyen' ? 'payauthority-detail' : 'payservice-detail';
        const routeData = this.$router.resolve({
            name: routeName,
            params: { id: item.id.toString() }
        });
        window.open(routeData.href, '_blank');
    }

    private get totalTthAmount(): number {
        return this.items.reduce((sum, it) => sum + (Number(it.total_amount) || 0), 0);
    }

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }

    private formatDate(d: string): string {
        if (!d) return '—';
        return d.replace('T', ' ').substring(0, 19);
    }

    private getStatusText(st: number, type: string): string {
        if (type === 'uy_quyen') {
            const map: Record<number, string> = {
                1: 'Chờ duyệt',
                2: 'Đã duyệt',
                3: 'Chờ thanh toán',
                4: 'Đã thanh toán',
                5: 'Đã hoàn thành',
                6: 'Đã hủy',
            };
            return map[st] || `Trạng thái ${st}`;
        }
        const map: Record<number, string> = {
            1: 'Chờ duyệt',
            2: 'Đã duyệt',
            3: 'Chờ thanh toán',
            4: 'Đã thanh toán',
            5: 'Đã hoàn thành',
            6: 'Đã hủy',
        };
        return map[st] || `Trạng thái ${st}`;
    }

    private getStatusBadgeClass(st: number): string {
        if ([4, 5].includes(st)) return 'label-success';
        if ([6].includes(st)) return 'label-danger';
        if ([2, 3].includes(st)) return 'label-primary';
        return 'label-warning';
    }
}
